import { roundCents } from "@tillix/utils/allocate-invoice-payments";

/**
 * Payment method types eligible for per-account convenience fees.
 * Mirrors the Prisma `PaymentMethodType` enum (CARD | BANK_ACCOUNT | THIRD_PARTY).
 * Duplicated here to keep this module free of a `@tillix/db` dependency.
 */
export type PayableMethodType = "CARD" | "BANK_ACCOUNT" | "THIRD_PARTY";

export const FEE_BY_METHOD: Record<PayableMethodType, number> = {
  CARD: 3.95,
  BANK_ACCOUNT: 0.49,
  THIRD_PARTY: 0,
};

export const FEE_LABELS: Record<PayableMethodType, string> = {
  CARD: "Card processing fee",
  BANK_ACCOUNT: "ACH processing fee",
  THIRD_PARTY: "",
};

export function computeFeeTotal(
  accountCount: number,
  perAccountFee: number,
): number {
  return roundCents(accountCount * perAccountFee);
}
